var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "2000px",
    height: "2000px",
    viewBox: "0 0 2000 2000",
    enableBackground: "new 0 0 2000 2000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_artwork"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Guides_to_delete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E34E26",
    points: "352.732,1718.4 208.627,101.984 1791.373,101.984 1647.093,1718.528 999.615,1898.016  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EF662A",
    points: "1000,234.108 1000,1760.716 1523.565,1615.585 1646.918,234.108  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "503.468,432.378 556.906,1031.897 1244.048,1031.897 1220.988,1289.041 999.744,1348.857  778.919,1289.128 764.155,1124.017 565.155,1124.017 593.611,1442.302 999.697,1555.086 1406.296,1442.302 1460.806,833.669  738.229,833.669 720.086,630.648 1478.168,630.648 1478.773,630.648 1496.532,432.378  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#EBEBEB",
    points: "1000,432.378 503.468,432.378 556.906,1031.897 1000,1031.897 1000,833.669 738.229,833.669  720.086,630.648 1000,630.648  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EBEBEB",
    points: "1000,1348.771 999.744,1348.857 778.919,1289.128 764.155,1124.017 565.155,1124.017  593.611,1442.302 999.697,1555.086 1000,1555.001  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.ed7faa621a87d5ccd4b73edbae4facb7.svg";
export { ForwardRef as ReactComponent };